exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "td[data-v-33f3f8e6],th[data-v-33f3f8e6]{font-weight:400}.confirm-selector-stock[data-v-33f3f8e6],.confirm-stock[data-v-33f3f8e6]{width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;padding:12px 0;background-color:#fff}.confirm-selector-stock[data-v-33f3f8e6]{position:absolute;bottom:0;left:0}", ""]);

// exports
